import {LocationType} from '@/services/ProjectAuthApi/types';

export const BACKGROUND_STYLE = {
  spot: {
    size: 300,
    radius: 212.13,
    colorStopList: [
      {
        color: 'rgba(255, 255, 255, 0.15)',
        offset: 0.1,
      },
      {
        color: 'rgba(0, 0, 0, 0)',
        offset: 1,
      },
    ],
  },
  gradient: {
    [LocationType.Location1]: [
      {
        color: 0x0f0115,
        offset: 0,
      },
      {
        color: 0x16021e,
        offset: 0.3515,
      },
      {
        color: 0x2d0c63,
        offset: 1,
      },
    ],
    [LocationType.Location2]: [
      {
        color: 0x0f0115,
        offset: 0,
      },
      {
        color: 0x16021e,
        offset: 0.3515,
      },
      {
        color: 0x5d0c63,
        offset: 1,
      },
    ],
    [LocationType.Location3]: [
      {
        color: 0x0f0115,
        offset: 0,
      },
      {
        color: 0x16021e,
        offset: 0.3515,
      },
      {
        color: 0x0c5963,
        offset: 1,
      },
    ],
    [LocationType.Location4]: [
      {
        color: 0x0f0115,
        offset: 0,
      },
      {
        color: 0x16021e,
        offset: 0.3515,
      },
      {
        color: 0x095829,
        offset: 1,
      },
    ],
  },
};
